module.exports = __webpack_public_path__ + "static/media/10450_Rectangular_Grass_Patch_v1_iterations-2.972d22eb.obj";